var _rect, _rect2, _rect3, _rect4, _path, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemLayoutWithDesc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 58,
    viewBox: "0 0 118 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 58,
    rx: 5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 16,
    width: 49,
    height: 4,
    rx: 1.5,
    fill: "#B4B3B3",
    stroke: "#939393"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 26.5,
    width: 93,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 37.5,
    width: 63,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.3643 34.2529V35.7129H83.6123V34.2529H84.3643ZM84.2715 42.2266V43.5352H83.5244V42.2266H84.2715ZM85.0088 40.6494C85.0088 40.4606 84.9697 40.2962 84.8916 40.1562C84.8167 40.013 84.693 39.8844 84.5205 39.7705C84.348 39.6533 84.1169 39.5443 83.8271 39.4434C83.4105 39.2969 83.0459 39.1325 82.7334 38.9502C82.4242 38.7646 82.1833 38.5368 82.0107 38.2666C81.8415 37.9932 81.7568 37.653 81.7568 37.2461C81.7568 36.8457 81.848 36.499 82.0303 36.2061C82.2158 35.9131 82.473 35.6868 82.8018 35.5273C83.1305 35.3678 83.5146 35.2881 83.9541 35.2881C84.2926 35.2881 84.597 35.3385 84.8672 35.4395C85.1406 35.5404 85.3734 35.6885 85.5654 35.8838C85.7575 36.0791 85.904 36.32 86.0049 36.6064C86.109 36.8896 86.1611 37.2152 86.1611 37.583H84.9893C84.9893 37.3747 84.9648 37.1891 84.916 37.0264C84.8704 36.8604 84.8021 36.7204 84.7109 36.6064C84.6198 36.4893 84.5091 36.3997 84.3789 36.3379C84.252 36.276 84.1071 36.2451 83.9443 36.2451C83.7132 36.2451 83.5228 36.2891 83.373 36.377C83.2233 36.4616 83.1126 36.5788 83.041 36.7285C82.9727 36.8783 82.9385 37.0492 82.9385 37.2412C82.9385 37.4268 82.9743 37.5895 83.0459 37.7295C83.1175 37.8695 83.2396 37.9964 83.4121 38.1104C83.5879 38.221 83.8288 38.3333 84.1348 38.4473C84.5547 38.597 84.9176 38.7646 85.2236 38.9502C85.5329 39.1325 85.7705 39.3587 85.9365 39.6289C86.1058 39.8958 86.1904 40.2327 86.1904 40.6396C86.1904 41.0596 86.0928 41.416 85.8975 41.709C85.7054 42.002 85.4352 42.2249 85.0869 42.3779C84.7419 42.5277 84.3398 42.6025 83.8809 42.6025C83.5911 42.6025 83.3031 42.5651 83.0166 42.4902C82.7334 42.4121 82.4762 42.2852 82.2451 42.1094C82.014 41.9336 81.8301 41.7008 81.6934 41.4111C81.5566 41.1182 81.4883 40.7601 81.4883 40.3369H82.6699C82.6699 40.5908 82.7041 40.8024 82.7725 40.9717C82.8408 41.141 82.9336 41.2744 83.0508 41.3721C83.168 41.4697 83.2982 41.5397 83.4414 41.582C83.5879 41.6243 83.7344 41.6455 83.8809 41.6455C84.125 41.6455 84.3301 41.6048 84.4961 41.5234C84.6654 41.4388 84.7923 41.3216 84.877 41.1719C84.9648 41.0189 85.0088 40.8447 85.0088 40.6494Z",
    fill: "#3A3A3A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 57,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLayoutWithDesc);
export default __webpack_public_path__ + "static/media/ItemLayoutWithDesc.2f98ad4f342cf911edcdcb8da59926b5.svg";
export { ForwardRef as ReactComponent };